/**
 * Eventos de GA4.
 *
 * O `gtag` só existe quando o layout injetou o script (GA_MEASUREMENT_ID no
 * env) — em dev e test ele não existe, e chamar direto explodiria. Por isso
 * tudo passa por aqui: a guarda mora num lugar só, e quem dispara evento não
 * precisa lembrar dela.
 *
 * Mesmo padrão do listener de `page_view` em entrypoints/inertia.tsx.
 */
type Gtag = (command: string, name: string, params?: EventParams) => void

/** Só o que o GA4 aceita num parâmetro de evento. */
export type EventParams = Record<string, string | number | boolean | undefined>

function gtag(): Gtag | null {
  const fn = (window as Window & { gtag?: Gtag }).gtag
  return typeof fn === 'function' ? fn : null
}

export function trackEvent(name: string, params: EventParams = {}): void {
  gtag()?.('event', name, params)
}

/**
 * A conversão que importa para o negócio.
 *
 * Não é "visitou a página": é o clique que abre a conversa com o negócio. É
 * este o evento que o Google Ads precisa para otimizar campanha — sem ele, a
 * campanha otimiza por tráfego, que é o sinal errado.
 *
 * ATENÇÃO (fora do código): o evento precisa ser marcado como "evento
 * principal" (key event) no painel do GA4. Sem isso ele chega, aparece nos
 * relatórios, mas não vira coluna de conversão e o Ads não consegue usá-lo.
 */
export const WHATSAPP_CLICK_EVENT = 'whatsapp_click'

export interface WhatsAppClickParams extends EventParams {
  /** De onde saiu o clique — "school_landing", "pricing", "header"… */
  source: string
  /** "school" | "creator_page" | "bewave" (o número da própria BeWave). */
  listing_type?: string
  /** Slug do negócio, quando o clique é na página de um. */
  listing_slug?: string
}

export function trackWhatsAppClick(params: WhatsAppClickParams): void {
  trackEvent(WHATSAPP_CLICK_EVENT, params)
}
